var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-plot"},[_c('svg',{ref:"circleSVG"}),(_vm.percentage)?_c('div',{staticClass:"number"},[_vm._v(_vm._s(_vm.percentage)+"%")]):_vm._e(),_c('div',{staticClass:"label",domProps:{"innerHTML":_vm._s(_vm.label)}})])}
var staticRenderFns = []

export { render, staticRenderFns }